export function useRewardPoints() {
  const { locale } = useI18n();
  return `https://secure.accor.com/account/index.${locale.value}.shtml#/my-loyalty-program`;
}
